import React from 'react';
import tpl from '../templates/acceptingPayments';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'recipient'
        };
    }

    shouldFetchData() {
        return false;
    }

    static displayName = 'AcceptingPayments.Views.Main';
}
